export const TRANSITION_TIMEOUT_TIME = 400;

export const NAVIGATION_BLOCKS = {
  CUSTOMER_MATCHES: 'CUSTOMER_MATCHES',
  APPOINTMENT_BOOKING: 'APPOINTMENT_BOOKING',
  GET_DYNAMIC_NEWSLETTER: 'GET_DYNAMIC_NEWSLETTER',
  SELECT_AND_CONNECT: 'SELECT_AND_CONNECT',
};

// The cause of the submission block. Currently only INPUT_VALUE is supported but in future we could have causes such as results of a external API call.
export const SUBMISSION_BLOCK_TYPES = {
  INPUT_VALUE: 'INPUT_VALUE',
};

// The message to be shown to the customer when a submission block is encountered.
export const SUBMISSION_BLOCK_MESSAGES = {
  INVALID_POSTCODE:
    'Sorry, we are unable to connect you with a provider nearby.',
};

/**
 * If any of these statements change, the hash needs to be updated.
 * Use the https://eagle.mvfglobal.com/api/v1/legal-statement/import endpoint to import the new statement wording.
 * The hash can be put in the corresponding entry in the STATEMENT_HASH_OVERRIDES object.
 */
export const STATEMENT_OVERRIDES = {
  EMAIL_ONLY:
    "By entering your email, you agree to Marketing VF Ltd collecting and using the data you've submitted up to this point to sign you up for updates about this and other related products. Unsubscribe at any time.",
};

export const STATEMENT_HASH_OVERRIDES = {
  EMAIL_ONLY: 'fa03cb0c9cd6c97f8ddab6beaf576962',
};
